import {Graphics, RenderTexture, Text, Texture} from 'pixi.js';
import {PixiApplicationController} from '../controllers/PixiApplicationController';
import {TextFactory} from '../factories/TextFactory';

export class TextureUrlLoader
{
    static loadedTextures: Map<string, Texture> = new Map<string, Texture>();

    /**
     * Загрузка текстуры по пути
     * @param path - относительный путь к картинке
     */
    static async load(path: string, width: number = 0, height: number = 0): Promise<Texture | null> {
        let texture: Texture | undefined = TextureUrlLoader.loadedTextures.get(path);
        if (texture) {
            return texture;
        }
        try {
            texture = await Texture.fromURL(path);
        } catch (err) {
            console.warn('FAILED loading texture:', path);
            return width > 0 && height > 0 ? TextureUrlLoader.getMockup(path, width, height) : null;
        }
        TextureUrlLoader.loadedTextures.set(path, texture);
        return texture;
    }

    static forget(texture: Texture): void {
        let textureKey: string = '';
        TextureUrlLoader.loadedTextures.forEach((loadedTexture: Texture, key: string) => {
            if (loadedTexture === texture) {
                textureKey = key;
            }
        });
        TextureUrlLoader.loadedTextures.delete(textureKey);
    }

    private static getMockup(path: string, width: number, height: number): Texture {
        let renderTexture = RenderTexture.create({width, height});
        let graphics: Graphics = new Graphics();
        graphics.beginFill(0xff0000);
        graphics.drawRoundedRect(0, 0, width, height, 10);
        graphics.endFill();
        let text: Text = TextFactory.create('Failed to load texture: ' + path);
        text.x = text.y = 10;
        PixiApplicationController.app.renderer.render(graphics, {renderTexture});
        PixiApplicationController.app.renderer.render(text, {renderTexture, clear: false});

        return renderTexture;
    }
}
